module.exports = __webpack_public_path__ + "img/steel-sheet-card.08397e9d.jpg";